import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate, useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import countries from "../../../components/Json/country.json";

// @mui icons
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CommonLayout from "components/CommonLayout";

// Images
import bgImage from "assets/images/background.png";
import product1 from "assets/images/product1.png";

//form
import * as Yup from "yup";
import { isString, useFormik } from "formik";

import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import { useAddProductMutation } from "services/product";
import ShowToast from "components/MDToast";
import { isNumber } from "utils/validations";
import { useLazyGetCategoryQuery } from "services/product";
import { useLazyGetSubCategoryQuery } from "services/product";
import { UploadMedia } from "utils/mediaUpload";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import { useAppDispatch } from "hooks/store";
import { setCredentials } from "reducers/authSlice";
import { useAppSelector } from "hooks/store";
import { getToken } from "reducers/authSlice";
import { useLazyGetProductByIdQuery } from "services/product";
import { useUpdateProfileMutation } from "services/auth";
import { useUpdateProductMutation } from "services/product";
import useTranslation from "hooks/Translation";

const AddProducts = () => {
  const navigate = useNavigate();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const { id } = useParams();
  const t = useTranslation();
  const usedispatch = useAppDispatch();
  const [productById, { isLoading }] = useLazyGetProductByIdQuery();
  const [productData, setProductData] = useState();

  const myToken = useAppSelector(getToken);
  const [addProduct] = useAddProductMutation();
  const [getSubCategory] = useLazyGetSubCategoryQuery();
  const [updateProduct] = useUpdateProductMutation();
  const [getCategory] = useLazyGetCategoryQuery();
  const [myImages, setMyImages] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedPlace, setSelectedPlace] = useState("");
  const [error, setError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [bulkPricing, setBulkPricing] = useState([]);
  const currency = getFromStorage(STORAGE_KEYS.currency);

  const handleAddRow = () => {
    setBulkPricing([...bulkPricing, { minQty: "", maxQty: "", price: "" }]);
  };

  const handleRemoveRow = (index) => {
    setBulkPricing(bulkPricing.filter((_, i) => i !== index));
  };

  const handleBulkChange = (index, field, value) => {
    const updatedBulkPricing = [...bulkPricing];
    updatedBulkPricing[index] = {
      ...updatedBulkPricing[index], // Spread existing object
      [field]: value, // Update the specific field
    };
    setBulkPricing((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const [isPerUnit, setIsPerUnit] = useState(false);
  console.log(isPerUnit, "isPerUnit");

  const handleToggle = () => {
    setIsPerUnit(!isPerUnit);
  };

  const handlePricingChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleSubCategoryChange = (event) => {
    setSelectedSubCategory(event.target.value);
  };

  const handleUnitChange = (event) => {
    setSelectedUnit(event.target.value);
  };

  const handlePlaceChange = (event) => {
    setSelectedPlace(event.target.value);
  };

  const handleCrossClick = async (e, i) => {
    e.stopPropagation();
    if (myImages.includes(i)) {
      let arr = [];
      arr = myImages.filter((name) => name !== i);
      setMyImages(arr);
    }
  };

  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (files) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const invalidFiles = Array.from(files).filter(
        (file) => !allowedTypes.includes(file.type)
      );
      if (invalidFiles.length > 0) {
        ShowToast("Invalid image please upload again", "error");
        return;
      }
      if (myImages.length + files.length > 10) {
        ShowToast("Maximum 10 images are allowed");
        return;
      }
      const uploadedImages = Array.from(files).map((file) => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setMyImages((prevImages) => [...prevImages, ...uploadedImages]);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      product_image: "",
      product_name_ar: productData?.product_name_ar || "",
      product_name_en: productData?.product_name_en || "",
      product_name_rs: productData?.product_name_rs || "",
      price_per_unit: productData?.price_per_unit || "",
      price_per_unit_package: productData?.price_per_unit || "",
      total_quantity: productData?.total_quantity || "",
      quantity_per_unit_package: productData?.quantity_per_unit || "",
      grade_ar: productData?.grade_ar || "",
      grade_en: productData?.grade_en || "",
      grade_rs: productData?.grade_rs || "",
      model_no_en: productData?.model_no_en || "",
      model_no_ar: productData?.model_no_ar || "",
      model_no_rs: productData?.model_no_rs || "",
      shell_life_en: productData?.shell_life_en || "",
      shell_life_ar: productData?.shell_life_ar || "",
      shell_life_rs: productData?.shell_life_rs || "",
      style_en: productData?.style_en || "",
      style_ar: productData?.style_ar || "",
      style_rs: productData?.style_rs || "",
      place_of_origin_en: "",
      place_of_origin_ar: "",
      place_of_origin_rs: "",
      product_type_en: productData?.product_type_en || "",
      product_type_ar: productData?.product_type_ar || "",
      product_type_rs: productData?.product_type_rs || "",
      product_desc_en: productData?.product_desc_en || "",
      product_desc_ar: productData?.product_desc_ar || "",
      product_desc_rs: productData?.product_desc_rs || "",
      // delivery_time: productData?.delivery_time || "",
      // shipping: "",
      bulk_pricing: [],
      min_quantity: productData?.min_quantity || "",
      min_quantity_package: productData?.min_quantity || "",
    },
    validationSchema: Yup.object({
      product_name_en: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation)
        .min(2, t.error.minValidation),
      product_name_ar: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation)
        .min(2, t.error.minValidation),
      product_name_rs: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation)
        .min(2, t.error.minValidation),
      price_per_unit: isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
      price_per_unit_package: !isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
      total_quantity: Yup.string().required(t.error.required),

      quantity_per_unit_package: !isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),

      grade_ar: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      grade_en: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      grade_rs: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      model_no_en: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      model_no_ar: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      model_no_rs: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      shell_life_en: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      shell_life_ar: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      shell_life_rs: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      style_en: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      style_ar: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      style_rs: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      product_type_en: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      product_type_ar: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      product_type_rs: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation),

      product_desc_en: Yup.string().required(t.error.required),

      product_desc_ar: Yup.string().required(t.error.required),

      product_desc_rs: Yup.string().required(t.error.required),

      min_quantity: isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
      min_quantity_package: !isPerUnit
        ? Yup.string().notRequired()
        : Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      // if (!profilePicture) {
      //   warnToast("Please upload an image");
      //   return;
      // }
      let images = [];
      if (!id && myImages?.length) {
        await Promise.all(
          myImages?.map(async (item) => {
            if (id) {
              const res = await UploadMedia(item?.media_url);
              if (res?.status === 200 && res?.data?.length) {
                images?.push(res?.data[0]?.id);
              }
            } else {
              const res = await UploadMedia(item?.file);
              if (res?.status === 200 && res?.data?.length) {
                images?.push(res?.data[0]?.id);
              }
            }
          })
        );
      }
      if (!id && !images?.length) {
        ShowToast(t.error.uploadImage, "error");
        return;
      }

      console.log(images);

      const body = {
        sub_category: selectedSubCategory,
        product_image: id ? myImages?.map((item) => item?.id) : images,
        product_name_ar: values.product_name_ar || "",
        product_name_en: values.product_name_en || "",
        product_name_rs: values.product_name_rs || "",
        price_per_unit: isPerUnit
          ? Number(values.price_per_unit_package)
          : Number(values.price_per_unit),
        total_quantity: values.total_quantity || "100",
        quantity_per_unit: isPerUnit
          ? values.quantity_per_unit_package
          : values.quantity_per_unit || "",
        grade_ar: values.grade_ar || "",
        grade_en: values.grade_en || "",
        grade_rs: values.grade_rs || "",
        model_no_en: values.model_no_en || "",
        model_no_ar: values.model_no_ar || "",
        model_no_rs: values.model_no_rs || "",
        shell_life_en: values.shell_life_en || "",
        shell_life_ar: values.shell_life_ar || "",
        shell_life_rs: values.shell_life_rs || "",
        style_en: values.style_en || "",
        style_ar: values.style_ar || "",
        style_rs: values?.style_rs || "",
        place_of_origin_en: [selectedCountry],
        place_of_origin_ar: [selectedCountry],
        place_of_origin_rs: [selectedCountry],
        product_type_en: values.product_type_en || "",
        product_type_ar: values.product_type_ar || "",
        product_type_rs: values.product_type_rs || "",
        product_desc_en: values.product_desc_en || "Test",
        product_desc_ar: values.product_desc_ar || "Test",
        product_desc_rs: values.product_desc_rs || "Test",
        // delivery_time: values.delivery_time || "",
        // shipping: values.shipping || "",
        bulk_pricing: bulkPricing,
        product_status: 3,
        product_type: isPerUnit ? 1 : 2,
        category: selectedCategory,
        product_quantity_type: 1,
        min_quantity: isPerUnit
          ? Number(values.min_quantity_package)
          : Number(values.min_quantity),
      };

      console.log(body, "MY_BODY_______>>>>");
      if (!id)
        try {
          const response = await addProduct(body).unwrap();
          if (response.status === 200) {
            ShowToast(response.data.message || t.main.productAdded);
            navigate("/product-listing");
          } else {
            ShowToast(response.data.message || "", "error");
          }
        } catch (e) {
          ShowToast(e?.data?.message, "error");
        }
      else {
        try {
          const response = await updateProduct({
            id: id,
            body: body,
          }).unwrap();
          if (response.status === 200) {
            ShowToast(t.main.productUpdated);
            navigate("/product-listing");
          } else {
            ShowToast(response?.message || "", "error");
          }
        } catch (e) {
          ShowToast(e?.message || "", "error");
        }
      }
    },
  });

  const getCategoryDetail = async () => {
    try {
      const res = await getCategory({}).unwrap();
      if (res?.status === 200) {
        setCategoryData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const getSubCategoryDetail = async () => {
    try {
      const res = await getSubCategory({ id: selectedCategory }).unwrap();
      if (res?.status === 200) {
        setSubCategoryData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  // const handleImageUpload = async (event) => {
  //   const files = event.target.files;
  //   const file = files?.length ? files[0] : null;

  //   try {
  //     if (!file) {
  //       setProfilePicture("");
  //       // setImageError("Image is required");
  //       return;
  //     }

  //     const res = await UploadMedia(file);
  //     if (res?.status === 200) {
  //       const imageUrl = res?.data[0]?.media_url;
  //       setProfilePicture(imageUrl);
  //       setImageId(res?.data[0]?.id);
  //       successToast("Image uploaded successfully.");
  //     } else {
  //       errorToast(res?.message);
  //     }
  //   } catch (error) {
  //     console.error("Error uploading image:", error);
  //     errorToast("Error uploading image. Please try again.");
  //   }
  // };

  const getProductDetails = async () => {
    try {
      const res = await productById({ id }).unwrap();
      if (res?.status === 200) {
        setProductData(res?.data);
        setMyImages(res?.data?.product_image);
        setIsPerUnit(res?.data?.product_type === 1 ? true : false);
        setSelectedUnit(String(res?.data?.product_quantity_type));
        setSelectedSubCategory(res?.data?.sub_category?.id);
        setSelectedCategory(res?.data?.sub_category?.category?.id);
        setSelectedPlace(res?.data?.place_of_origin_en[0]);
        setBulkPricing(res?.data?.bulk_pricing);
        setSelectedCountry(res?.data?.place_of_origin_en[0]);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  useEffect(() => {
    if (id) {
      getProductDetails();
    }
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      getSubCategoryDetail();
    }
  }, [selectedCategory]);

  useEffect(() => {
    getCategoryDetail();
  }, []);

  return (
    <CommonLayout image={bgImage}>
      <Card sx={{ marginTop: 10, marginBottom: 10 }}>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
          // textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {id ? t.main.editProduct : t.main.addProduct}
          </MDTypography>

          <MDTypography
            variant="h6"
            color="white"
            mt={1}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/product-listing")}
          >
            {t.main.back}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2} className="form_control">
                  <Grid
                    item
                    lg={3}
                    md={3}
                    sm={6}
                    xs={12}
                    className="upload_document v2 w_50"
                  >
                    <MDTypography variant="h6" mb={1}>
                      {t.main.images}
                    </MDTypography>
                    {myImages?.length >= 10 ? null : (
                      <Box className="upload_image_bnr">
                        <label htmlFor="icon-button-file-vdo">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file-vdo"
                            type="file"
                            inputProps={{
                              accept: ".png, .jpg, .jpeg, .svg",
                              multiple: true,
                            }}
                            onChange={handleFileUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <AddIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  {myImages?.length ? (
                    <>
                      {myImages?.map((item, i) => {
                        return (
                          <Grid
                            item
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className="upload_document w_50"
                            key={i}
                            style={{ cursor: "pointer", marginTop: "36px" }}
                            // onClick={() => {
                            //   setOpen_gallery(true);
                            //   setPreview(item?.url);
                            // }}
                          >
                            <div className="inner">
                              <div className="cross_icn">
                                <CloseIcon
                                  onClick={(e) => handleCrossClick(e, item)}
                                />
                              </div>

                              <figure>
                                <img
                                  src={item?.url || item?.media_url}
                                  alt="upload"
                                />
                              </figure>
                            </div>
                          </Grid>
                        );
                      })}
                    </>
                  ) : null}
                </Grid>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.productNameEn}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.productNameEn}
                    id="product_name_en"
                    name="product_name_en"
                    variant="outlined"
                    fullWidth
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_name_en}
                    helperText={
                      formik.touched.product_name_en &&
                      formik.errors.product_name_en
                    }
                    error={
                      formik.touched.product_name_en &&
                      formik.errors.product_name_en
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.productNameAr}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.productNameAr}
                    fullWidth
                    variant="outlined"
                    id="product_name_ar"
                    name="product_name_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_name_ar}
                    helperText={
                      formik.touched.product_name_ar &&
                      formik.errors.product_name_ar
                    }
                    error={
                      formik.touched.product_name_ar &&
                      formik.errors.product_name_ar
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.productNameRu}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.productNameRu}
                    variant="outlined"
                    fullWidth
                    id="product_name_rs"
                    name="product_name_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_name_rs}
                    helperText={
                      formik.touched.product_name_rs &&
                      formik.errors.product_name_rs
                    }
                    error={
                      formik.touched.product_name_rs &&
                      formik.errors.product_name_rs
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.category}
                </MDTypography>
                <FormControl sx={{ width: "100%" }}>
                  <Select
                    className="select_div"
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={priceType}
                    value={selectedCategory}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    sx={{
                      border:
                        error && !selectedCategory
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                    displayEmpty
                    onChange={handlePricingChange}
                    error={error && !selectedCategory}
                  >
                    <MenuItem value="" disabled>
                      {t.main.selectCategory}
                    </MenuItem>
                    {categoryData?.length
                      ? categoryData?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item?.category_name || ""}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                  {error && !selectedCategory ? (
                    <MDTypography className="err_msg">
                      {t.main.categoryReq}
                    </MDTypography>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.subCategory}
                </MDTypography>
                <FormControl sx={{ width: "100%" }}>
                  <Select
                    className="select_div"
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={priceType}
                    value={selectedSubCategory}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    onChange={handleSubCategoryChange}
                    error={error && !selectedSubCategory}
                    sx={{
                      border:
                        error && !selectedSubCategory
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t.main.selectCategory}
                    </MenuItem>
                    {subCategoryData?.length
                      ? subCategoryData?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item?.sub_category_name || ""}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                  {error && !selectedSubCategory ? (
                    <MDTypography className="err_msg">
                      {t.main.subCategoryReq}
                    </MDTypography>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.gradeEn}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.gradeEn}
                    variant="outlined"
                    fullWidth
                    id="grade_en"
                    name="grade_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.grade_en}
                    helperText={
                      formik.touched.grade_en && formik.errors.grade_en
                    }
                    error={formik.touched.grade_en && formik.errors.grade_en}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.gradeAr}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.gradeAr}
                    variant="outlined"
                    fullWidth
                    id="grade_ar"
                    name="grade_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.grade_ar}
                    helperText={
                      formik.touched.grade_ar && formik.errors.grade_ar
                    }
                    error={formik.touched.grade_ar && formik.errors.grade_ar}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.gradeRu}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.gradeRu}
                    variant="outlined"
                    fullWidth
                    id="grade_rs"
                    name="grade_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.grade_rs}
                    helperText={
                      formik.touched.grade_rs && formik.errors.grade_rs
                    }
                    error={formik.touched.grade_rs && formik.errors.grade_rs}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.modelEn}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.modelEn}
                    variant="outlined"
                    fullWidth
                    id="model_no_en"
                    name="model_no_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.model_no_en}
                    helperText={
                      formik.touched.model_no_en && formik.errors.model_no_en
                    }
                    error={
                      formik.touched.model_no_en && formik.errors.model_no_en
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.modelAr}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.modelAr}
                    variant="outlined"
                    fullWidth
                    id="model_no_ar"
                    name="model_no_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.model_no_ar}
                    helperText={
                      formik.touched.model_no_ar && formik.errors.model_no_ar
                    }
                    error={
                      formik.touched.model_no_ar && formik.errors.model_no_ar
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.modelRu}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.modelRu}
                    variant="outlined"
                    fullWidth
                    id="model_no_rs"
                    name="model_no_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.model_no_rs}
                    helperText={
                      formik.touched.model_no_rs && formik.errors.model_no_rs
                    }
                    error={
                      formik.touched.model_no_rs && formik.errors.model_no_rs
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.shelfEn}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.shelfEn}
                    variant="outlined"
                    fullWidth
                    id="shell_life_en"
                    name="shell_life_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.shell_life_en}
                    helperText={
                      formik.touched.shell_life_en &&
                      formik.errors.shell_life_en
                    }
                    error={
                      formik.touched.shell_life_en &&
                      formik.errors.shell_life_en
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.shelfAr}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.shelfAr}
                    variant="outlined"
                    fullWidth
                    id="shell_life_ar"
                    name="shell_life_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.shell_life_ar}
                    helperText={
                      formik.touched.shell_life_ar &&
                      formik.errors.shell_life_ar
                    }
                    error={
                      formik.touched.shell_life_ar &&
                      formik.errors.shell_life_ar
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.shelfRu}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.shelfRu}
                    variant="outlined"
                    fullWidth
                    id="shell_life_rs"
                    name="shell_life_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.shell_life_rs}
                    helperText={
                      formik.touched.shell_life_rs &&
                      formik.errors.shell_life_rs
                    }
                    error={
                      formik.touched.shell_life_rs &&
                      formik.errors.shell_life_rs
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.styleEn}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.styleEn}
                    variant="outlined"
                    fullWidth
                    id="style_en"
                    name="style_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.style_en}
                    helperText={
                      formik.touched.style_en && formik.errors.style_en
                    }
                    error={formik.touched.style_en && formik.errors.style_en}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.styleAr}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.styleAr}
                    variant="outlined"
                    fullWidth
                    id="style_ar"
                    name="style_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.style_ar}
                    helperText={
                      formik.touched.style_ar && formik.errors.style_ar
                    }
                    error={formik.touched.style_ar && formik.errors.style_ar}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.styleRu}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.styleRu}
                    variant="outlined"
                    fullWidth
                    id="style_rs"
                    name="style_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.style_rs}
                    helperText={
                      formik.touched.style_rs && formik.errors.style_rs
                    }
                    error={formik.touched.style_rs && formik.errors.style_rs}
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.productTypeEn}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.productTypeEn}
                    variant="outlined"
                    fullWidth
                    id="product_type_en"
                    name="product_type_en"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_type_en}
                    helperText={
                      formik.touched.product_type_en &&
                      formik.errors.product_type_en
                    }
                    error={
                      formik.touched.product_type_en &&
                      formik.errors.product_type_en
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.producTypeAr}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.producTypeAr}
                    variant="outlined"
                    fullWidth
                    id="product_type_ar"
                    name="product_type_ar"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_type_ar}
                    helperText={
                      formik.touched.product_type_ar &&
                      formik.errors.product_type_ar
                    }
                    error={
                      formik.touched.product_type_ar &&
                      formik.errors.product_type_ar
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.productTypeRu}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.productTypeRu}
                    variant="outlined"
                    fullWidth
                    id="product_type_rs"
                    name="product_type_rs"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.product_type_rs}
                    helperText={
                      formik.touched.product_type_rs &&
                      formik.errors.product_type_rs
                    }
                    error={
                      formik.touched.product_type_rs &&
                      formik.errors.product_type_rs
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.placeOfOrigin}
                  </MDTypography>
                  <FormControl fullWidth className="ht_auto">
                    <Autocomplete
                      // multiple
                      options={countries || []}
                      getOptionLabel={(option) => option?.name || "No Name"}
                      style={{ direction: getLang === "ar" ? "rtl" : "ltr" }}
                      value={
                        countries?.find(
                          (item) => item?.name === selectedCountry
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        // event.preventDefault();
                        setSelectedCountry(newValue?.name || "");
                      }}
                      ListboxProps={{
                        style: { maxHeight: "200px" }, // Adjust dropdown height here
                      }}
                      renderInput={(params) => (
                        <div className="v12">
                          <MDInput
                            {...params}
                            variant="outlined"
                            placeholder={t.main.select}
                            error={error && !selectedCountry}

                            // style={{ position: "absolute", right: "33px" }}
                          />
                        </div>
                      )}
                    />
                    {error && !selectedCountry ? (
                      <h6 className="err_msg">{t.error.required}</h6>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.availableStock}
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.availableStock}
                    variant="outlined"
                    fullWidth
                    inputProps={{ maxLength: 10 }}
                    id="total_quantity"
                    name="total_quantity"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.total_quantity}
                    helperText={
                      formik.touched.total_quantity &&
                      formik.errors.total_quantity
                    }
                    error={
                      formik.touched.total_quantity &&
                      formik.errors.total_quantity
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.priceUnit}
                  </MDTypography>
                  <FormControl fullWidth>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      displayEmpty
                      value={selectedUnit}
                      onChange={handleUnitChange}
                      error={error && !selectedUnit}
                      sx={{
                        border:
                          error && !selectedUnit
                            ? "1px solid red"
                            : "1px solid grey", // Add a custom border color
                        borderRadius: "6px", // Optional: Add border radius for styling
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "grey", // Adjust border color for the outlined variant
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "grey", // Border color on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "grey", // Border color when focused
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        {t.main.select}
                      </MenuItem>

                      <MenuItem value={"1"}>KG</MenuItem>
                      <MenuItem value={"2"}>Liter</MenuItem>
                    </Select>
                    {error && !selectedUnit ? (
                      <MDTypography className="err_msg">
                        {t.error.required}
                      </MDTypography>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </MDBox>
              </Grid>

              <Grid item xs={12}>
                {/* Other fields */}

                <MDBox
                  display="flex"
                  alignItems="center"
                  sx={{ paddingBottom: "5px" }}
                >
                  <Switch checked={isPerUnit} onChange={handleToggle} />
                  <MDTypography variant="subtitle2">
                    {t.main.makeAsPackage}
                  </MDTypography>
                </MDBox>

                {/* Conditionally render the fields */}
                {isPerUnit ? (
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <MDBox>
                        <MDTypography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {t.main.quantityPerUnit}
                        </MDTypography>
                        <MDInput
                          type="text"
                          placeholder={t.main.quantityPerUnit}
                          variant="outlined"
                          fullWidth
                          id="quantity_per_unit_package"
                          name="quantity_per_unit_package"
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isNumber(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.quantity_per_unit_package}
                          helperText={
                            formik.touched.quantity_per_unit_package &&
                            formik.errors.quantity_per_unit_package
                          }
                          error={
                            formik.touched.quantity_per_unit_package &&
                            formik.errors.quantity_per_unit_package
                          }
                        />
                      </MDBox>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <MDTypography
                        variant="subtitle2"
                        className="custom_label"
                      >
                        {t.main.pricePerUnit}
                      </MDTypography>
                      <MDBox>
                        <MDInput
                          type="text"
                          placeholder={t.main.pricePerUnit}
                          variant="outlined"
                          fullWidth
                          id="price_per_unit_package"
                          name="price_per_unit_package"
                          inputProps={{ maxLength: 10 }}
                          onChange={(val) => {
                            const value = val.target.value;
                            if (value === " " || value === ".") return;

                            // Regex to allow only numbers with up to two decimal places
                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.price_per_unit_package}
                          helperText={
                            formik.touched.price_per_unit_package &&
                            formik.errors.price_per_unit_package
                          }
                          error={
                            formik.touched.price_per_unit_package &&
                            formik.errors.price_per_unit_package
                          }
                          endAdornment={
                            <InputAdornment position="end">kg</InputAdornment>
                          }
                        />
                      </MDBox>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <MDBox>
                        <MDTypography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {t.main.minPerchaseQty}
                        </MDTypography>
                        <MDInput
                          type="text"
                          placeholder={t.main.minPerchaseQty}
                          variant="outlined"
                          fullWidth
                          id="min_quantity_package"
                          name="min_quantity_package"
                          inputProps={{ maxLength: 10 }}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isNumber(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.min_quantity_package}
                          helperText={
                            formik.touched.min_quantity_package &&
                            formik.errors.min_quantity_package
                          }
                          error={
                            formik.touched.min_quantity_package &&
                            formik.errors.min_quantity_package
                          }
                        />
                      </MDBox>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <MDTypography
                        variant="subtitle2"
                        className="custom_label"
                      >
                        {selectedUnit === "1"
                          ? t.main.pricePerKg
                          : t.main.pricePerLiter}
                      </MDTypography>
                      <MDBox>
                        <MDInput
                          type="text"
                          placeholder={
                            selectedUnit === "1"
                              ? t.main.pricePerKg
                              : t.main.pricePerLiter
                          }
                          inputProps={{ maxLength: 10 }}
                          variant="outlined"
                          fullWidth
                          id="price_per_unit"
                          name="price_per_unit"
                          onChange={(val) => {
                            const value = val.target.value;
                            if (value === " " || value === ".") return;

                            // Regex to allow only numbers with up to two decimal places
                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.price_per_unit}
                          helperText={
                            formik.touched.price_per_unit &&
                            formik.errors.price_per_unit
                          }
                          error={
                            formik.touched.price_per_unit &&
                            formik.errors.price_per_unit
                          }
                        />
                      </MDBox>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <MDBox>
                        <MDTypography
                          variant="subtitle2"
                          className="custom_label"
                        >
                          {selectedUnit === "1"
                            ? t.main.minQtyKg
                            : t.main.minQtyLiter}
                        </MDTypography>
                        <MDInput
                          type="text"
                          placeholder={t.main.minPerchaseQty}
                          variant="outlined"
                          fullWidth
                          id="min_quantity"
                          name="min_quantity"
                          inputProps={{ maxLength: 10 }}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isNumber(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.min_quantity}
                          helperText={
                            formik.touched.min_quantity &&
                            formik.errors.min_quantity
                          }
                          error={
                            formik.touched.min_quantity &&
                            formik.errors.min_quantity
                          }
                        />
                      </MDBox>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.descEng}
                </MDTypography>
                <MDInput
                  type={"text"}
                  placeholder={t.main.descEng}
                  className="text_field"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={4}
                  id="product_desc_en"
                  name="product_desc_en"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.product_desc_en}
                  helperText={
                    formik.touched.product_desc_en &&
                    formik.errors.product_desc_en
                  }
                  error={
                    formik.touched.product_desc_en &&
                    formik.errors.product_desc_en
                  }
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.descAr}
                </MDTypography>
                <MDInput
                  type={"text"}
                  placeholder={t.main.descAr}
                  // className="text_field"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={4}
                  id="product_desc_ar"
                  name="product_desc_ar"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else if (isString(val.target.value)) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.product_desc_ar}
                  helperText={
                    formik.touched.product_desc_ar &&
                    formik.errors.product_desc_ar
                  }
                  error={
                    formik.touched.product_desc_ar &&
                    formik.errors.product_desc_ar
                  }
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.descRu}
                </MDTypography>
                <MDInput
                  type={"text"}
                  placeholder={t.main.descRu}
                  // className="text_field"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={4}
                  id="product_desc_rs"
                  name="product_desc_rs"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else if (isString(val.target.value)) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.product_desc_rs}
                  helperText={
                    formik.touched.product_desc_rs &&
                    formik.errors.product_desc_rs
                  }
                  error={
                    formik.touched.product_desc_rs &&
                    formik.errors.product_desc_rs
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <MDTypography variant="h6" mb={1}>
                  {t.main.bulkPricing}
                </MDTypography>
                <Box className="bulk_pricing_table">
                  {bulkPricing.map((row, index) => (
                    <Grid container spacing={2} key={index} mb={1}>
                      <Grid item xs={3}>
                        <MDBox>
                          <MDTypography
                            variant="subtitle2"
                            className="custom_label"
                          >
                            {t.main.minQty}
                          </MDTypography>
                          <MDInput
                            type="text"
                            placeholder={t.main.minQty}
                            variant="outlined"
                            fullWidth
                            value={row.minQty}
                            onChange={(e) =>
                              handleBulkChange(index, "minQty", e.target.value)
                            }
                          />
                        </MDBox>
                      </Grid>
                      <Grid item xs={3}>
                        <MDBox>
                          <MDTypography
                            variant="subtitle2"
                            className="custom_label"
                          >
                            {t.main.maxQty}
                          </MDTypography>
                          <MDInput
                            type="text"
                            placeholder={t.main.maxQty}
                            variant="outlined"
                            fullWidth
                            value={row.maxQty}
                            onChange={(e) =>
                              handleBulkChange(index, "maxQty", e.target.value)
                            }
                          />
                        </MDBox>
                      </Grid>
                      <Grid item xs={3}>
                        <MDBox>
                          <MDTypography
                            variant="subtitle2"
                            className="custom_label"
                          >
                            {t.main.price}
                          </MDTypography>
                          <MDInput
                            type="text"
                            placeholder={t.main.price}
                            variant="outlined"
                            fullWidth
                            value={row.price}
                            onChange={(val) => {
                              const value = val.target.value;
                              if (value === " " || value === ".") return;
                              // Regex to allow only numbers with up to two decimal places
                              if (/^\d*\.?\d{0,2}$/.test(value)) {
                                handleBulkChange(index, "price", value);
                              }
                            }}
                          />
                        </MDBox>
                      </Grid>
                      <Grid item xs={3} mt={3}>
                        <MDButton
                          onClick={() => handleRemoveRow(index)}
                          variant="outlined"
                          color="error"
                        >
                          {t.main.remove}
                        </MDButton>
                      </Grid>
                    </Grid>
                  ))}
                </Box>

                <MDButton
                  onClick={handleAddRow}
                  variant="gradient"
                  color="success"
                  sx={{ marginTop: 2 }}
                >
                  {t.main.addBulk}
                </MDButton>
              </Grid>
            </Grid>

            <MDButton
              onClick={() => {
                setError(true);
              }}
              type="submit"
              variant="gradient"
              color="success"
              sx={{ marginTop: 4 }}
            >
              {t.main.save}
            </MDButton>
          </form>
        </MDBox>
      </Card>
    </CommonLayout>
  );
};

export default AddProducts;
